import React, { useState, useEffect } from "react";
import ContentHeader from "../ShareElements/ContentHeader/ContentHeader";
import ImagePreloader from "../ShareElements/ImagePreloader/ImagePreloader";
import Circle from "../../../../Assets/Images/sm-Circle.svg";
import FormEmptyState from "../ShareElements/EmptyState/FormEmptyState";
import SearchInput from "../ShareElements/SearchInput/SearchInput";
import "../../../../Assets/Styles/ManualJPAs.scss";
import JPAItem from "./Components/JPAItem";
import Select from "../ShareElements/Select/Select";
import { NavLink } from "react-router-dom";
import { Config } from "../../../../Config";
import axios from "axios";

const ManualProjects = (props) => {
  const [JPAs, setJPAs] = useState([]);
  const [NoJPAsAvailable, setNoJPAsAvailable] = useState(false);
  const [PageInfo, setPageInfo] = useState({});
  const [Pages, setPages] = useState([1]);
  const [TotalElements, setTotalElements] = useState(9);
  const [InitialLoadIsDone, setInitialLoadIsDone] = useState(false); // to avoid seeing empty state on first page load
  const [SizeOptions] = useState([
    { name: 6, id: 6 },
    { name: 9, id: 9 },
    { name: 12, id: 12 },
  ]);
  const [SelectedSize, setSelectedSize] = useState(6);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchJPAs(true, 0, 6);
    removeLocalStorageItems();

    window.localStorage.setItem("JPAInitialFilters", "1");

    if (
      window.innerWidth > 450 &&
      document.getElementById("nav-/createProjects") !== null
    ) {
      //executed on component mount.
      document
        .getElementById("nav-/createProjects")
        .classList.add("active-node");
      return () => {
        //executed on component unmount.
        document
          .getElementById("nav-/createProjects")
          .classList.remove("active-node");
      };
    }
  }, []);

  const removeLocalStorageItems = () => {
    window.localStorage.removeItem("chat_jpaId");
    window.localStorage.removeItem("chat_recipientId");
    window.localStorage.removeItem("chat_workCiy");
    window.localStorage.removeItem("chat_title");
    window.localStorage.removeItem("chat_jpaType");
    window.localStorage.removeItem("TempChatroom");
    window.localStorage.removeItem("notif_candidate_name");
  };

  const fetchJPAs = (IsInitialLoad, Start, Size) => {
    let Data = {
      criteria: {
        titleLike: document.getElementById("search-input").value,
      },
      start: Start,
      size: Size,
    };
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setJPAs(Res.data.results);
        setTotalElements(Res.data.totalElements);
        if (Res.data.results.length === 0) {
          if (
            IsInitialLoad ||
            document.getElementById("search-input").value.length === 0
          ) {
            setNoJPAsAvailable(true);
          }
        } else {
          createPagination(Res.data.totalElements);
        }
        if (
          Res.data.totalElements < Size &&
          document.getElementById("end") !== null
        ) {
          document.getElementById("end").innerHTML = Res.data.totalElements;
          document
            .getElementById("next-page")
            .classList.add("page-btn-disabled");
        }
        if (IsInitialLoad) {
          setInitialLoadIsDone(true);
        }
      })
      .catch((Err) => {
        console.log(Err);
        if (IsInitialLoad) {
          setInitialLoadIsDone(true);
        }
      });
  };

  const createPagination = (TotalCount) => {
    let Size;
    if (document.getElementById("pre-selected-row-per-page") !== null) {
      Size = parseInt(
        document.getElementById("pre-selected-row-per-page").innerHTML
      );
    } else {
      Size = SelectedSize;
    }
    let Count = Math.ceil(TotalCount / Size);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };

  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };
  const updatePaginationlength = (PageNum) => {
    shortenPagination(Pages);
    if (PageNum === PageInfo.LastPage) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
    } else {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
    }
  };

  const updateActiveClass = (PageNumber) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
    }
    document
      .getElementById(PageNumber + "-page-btn")
      .classList.add("active-page");
  };
  const requestNextPage = () => {
    let NextPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          NextPage = parseInt(i + 1);
        }
      }
    }
    if (document.getElementById(NextPage + "-page-btn") !== null) {
      document.getElementById(NextPage + "-page-btn").click();
    }
  };
  const requestPrevPage = () => {
    let PrevPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          if (i === 1) {
            PrevPage = 1;
          } else {
            PrevPage = parseInt(i - 1);
          }
        }
      }
    }
    if (document.getElementById(PrevPage + "-page-btn") !== null) {
      document.getElementById(PrevPage + "-page-btn").click();
    }
  };

  const requestPageNumber = (PageNumber) => {
    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let NewStart = parseInt((PageNumber - 1) * Size);

    fetchJPAs(false, NewStart, Size);

    if (NewStart === 0) {
      document.getElementById("start").innerHTML = 1;
    } else {
      document.getElementById("start").innerHTML = NewStart + 1;
    }
    if (parseInt(document.getElementById("end").innerHTML) === TotalElements) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    } else {
      document.getElementById("end").innerHTML = parseInt(NewStart + Size);
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
    if (PageNumber === 1) {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
    updateActiveClass(PageNumber);
    updatePaginationlength(PageNumber);
  };
  const setSize = () => {
    let SelectedSize = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    setSelectedSize(SelectedSize);
    setTimeout(() => {
      if (document.getElementById("1-page-btn") !== null) {
        document.getElementById("1-page-btn").click();
      }
    }, 300);
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const resetFilters = () => {
    if (document.getElementById("clear-btn") !== null) {
      document.getElementById("clear-btn").click();
    }
    setTimeout(() => {
      refreshData();
    }, 500);
  };

  const refreshData = () => {
    Pages.map((Page) => {
      if (
        document.getElementById(Page + "-page-btn") !== null &&
        document
          .getElementById(Page + "-page-btn")
          .classList.contains("active-page")
      ) {
        document.getElementById(Page + "-page-btn").click();
      }
    });
  };

  return (
    <div className="main-content">
      <ImagePreloader Images={[]} />
      <ContentHeader
        LangData={props.LangData}
        PageName={translateText("create_projects")}
      />
      <div className="content-header">
        <div className="address">
          <p>{translateText("projects")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("create_projects")}</p>
        </div>
      </div>
      <div className="manual-jpas">
        <section className="form-head">
          <SearchInput
            OnChange={() => fetchJPAs(false, 0, SelectedSize)}
            Placeholder={translateText("search") + " ..."}
          />
          <NavLink className="is-desktop" to="/addNewProject">
            <span className="add-btn">
              <i className="feather-plus"></i> {translateText("new_project")}
            </span>
          </NavLink>
          <NavLink className="is-mobile" to="/addNewProject">
            <span className="add-btn">
              <i className="feather-plus"></i>
            </span>
          </NavLink>
        </section>
        {NoJPAsAvailable && InitialLoadIsDone ? (
          <FormEmptyState
            StateName={"projects"}
            ResetFilters={() => null}
            Message={"Currently, no projects are available."}
            LangData={props.LangData}
            ActionButton={<span hidden></span>}
          />
        ) : (
          <React.Fragment>
            {JPAs.length === 0 && InitialLoadIsDone ? (
              <FormEmptyState
                StateName={"project"}
                ResetFilters={() => resetFilters()}
                LangData={props.LangData}
                Message={translateText("empty_state_text")}
              />
            ) : (
              <React.Fragment>
                <div className="manual-jpas-wrapper">
                  {JPAs.map((JPA) => (
                    <JPAItem
                      IsProject
                      JPA={JPA}
                      RefreshData={() => refreshData()}
                      LangData={props.LangData}
                    />
                  ))}
                </div>
                <div
                  className="info-footer jpa-details-footer"
                  id="info-footer"
                >
                  <div className="pagenumber-summary">
                    {translateText("showing")} <p id="start">1</p>
                    {translateText("to")} <p id="end">3</p>
                    {translateText("of")} {TotalElements}{" "}
                    {translateText("items")}.
                  </div>
                  <section className="pagination-holder">
                    <button
                      onClick={() => requestPrevPage()}
                      id="prev-page"
                      className={
                        Pages.length < 6
                          ? "page-btn page-btn-disabled right-margined"
                          : "page-btn page-btn-disabled"
                      }
                    >
                      <i className="feather-chevron-left"></i>
                    </button>
                    <React.Fragment>
                      {Pages.length < 6 ? (
                        <React.Fragment>
                          {Pages.map((Page) => (
                            <React.Fragment>
                              {Page === 1 ? (
                                <button
                                  key={Page}
                                  onClick={() => requestPageNumber(Page)}
                                  className="page-btn active-page"
                                  id={Page + "-page-btn"}
                                >
                                  {Page}
                                </button>
                              ) : (
                                <button
                                  key={Page}
                                  onClick={() => requestPageNumber(Page)}
                                  className="page-btn"
                                  id={Page + "-page-btn"}
                                >
                                  {Page}
                                </button>
                              )}
                            </React.Fragment>
                          ))}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <button
                            onClick={() => requestPageNumber(1)}
                            className="page-btn active-page"
                            id={1 + "-page-btn"}
                          >
                            {1}
                          </button>
                          {PageInfo.FirstDotsShown ? <p>...</p> : null}
                          <button
                            onClick={() =>
                              requestPageNumber(
                                parseInt(PageInfo.MiddlePage - 1)
                              )
                            }
                            className="page-btn"
                            id={parseInt(PageInfo.MiddlePage - 1) + "-page-btn"}
                          >
                            {parseInt(PageInfo.MiddlePage - 1)}
                          </button>
                          {PageInfo.MiddlePage === PageInfo.LastPage ? null : (
                            <button
                              onClick={() =>
                                requestPageNumber(PageInfo.MiddlePage)
                              }
                              className="page-btn"
                              id={PageInfo.MiddlePage + "-page-btn"}
                            >
                              {PageInfo.MiddlePage}
                            </button>
                          )}
                          {parseInt(PageInfo.MiddlePage + 1) >=
                          PageInfo.LastPage ? null : (
                            <button
                              onClick={() =>
                                requestPageNumber(
                                  parseInt(PageInfo.MiddlePage + 1)
                                )
                              }
                              className="page-btn "
                              id={
                                parseInt(PageInfo.MiddlePage + 1) + "-page-btn"
                              }
                            >
                              {parseInt(PageInfo.MiddlePage + 1)}
                            </button>
                          )}
                          {!PageInfo.LastDotsShown ? <p>...</p> : null}
                          <button
                            onClick={() => requestPageNumber(PageInfo.LastPage)}
                            className="page-btn"
                            id={PageInfo.LastPage + "-page-btn"}
                          >
                            {PageInfo.LastPage}
                          </button>
                        </React.Fragment>
                      )}
                    </React.Fragment>
                    <button
                      onClick={() => requestNextPage()}
                      id="next-page"
                      className={
                        Pages.length < 6 ? "page-btn left-margined" : "page-btn"
                      }
                    >
                      <i className="feather-chevron-right"></i>
                    </button>
                  </section>
                  <div className="row-count-select">
                    <p className="row-info">
                      {translateText("items_per_page")}
                    </p>
                    <Select
                      Initial={"6"}
                      Options={SizeOptions}
                      IsWithId
                      PreSelectedId={"6"}
                      Id={"row-per-page"}
                      ChangeHandler={() =>
                        setTimeout(() => {
                          setSize();
                        }, 100)
                      }
                      ValidationError=""
                    />
                  </div>
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default ManualProjects;
